const FOCUSABLE = 'input:not([type="hidden"]):not([disabled]):not([readonly]), select:not([disabled]), textarea:not([disabled]), button[type="submit"]:not([disabled])';

// Odağı verilen alanın ardından gelen ilk görünür form alanına taşır (belge genelinde, DOM sırası)
export function focusAfter(el) {
  const els = [...document.querySelectorAll("input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), button:not([disabled])")].filter((x) => x.tabIndex >= 0 && x.offsetParent !== null);
  const n = els[els.indexOf(el) + 1];
  if (n) { n.focus(); if (n.tagName === "INPUT" && n.select) n.select(); }
}

// Enter → formdaki sıradaki kutuya geç (son kutudan sonra Kaydet düğmesine); form/fieldset düzeyinde onKeyDown olarak bağlanır.
// Alt bileşen Enter'ı kendisi işleyip preventDefault yaptıysa (arama listesi vb.) dokunmaz.
export const enterToNext = (e) => {
  if (e.key !== "Enter" || e.defaultPrevented || !["INPUT", "SELECT"].includes(e.target.tagName)) return;
  e.preventDefault();
  const root = e.target.closest("form") || document;
  const all = [...root.querySelectorAll(FOCUSABLE)];
  const next = all[all.indexOf(e.target) + 1];
  if (next) { next.focus(); if (typeof next.select === "function" && next.tagName === "INPUT") next.select(); }
};
